import React, {createContext, useState} from 'react';

export const PremiumAlertMessageContext = createContext({
  showAlert: false,
  message:'',
  setShowAlert: () => ({}),
  setPolicyTotalPremiumAmt:() => ({}),
  setPaymentTotalPremiumAmt:() => ({}),
});

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});


const PremiumAlertMessageProvider = ({ children }) => {
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [policyTotalPremium, setPolicyTotalPremium] = useState(-1);
  const [paymentTotalPremium, setPaymentTotalPremium] = useState(-1);

  const generateMessage = (policyTotal,paymentTotal)=>{
    const change = paymentTotal - policyTotal;
    const numberWithCurrency = formatter.format(Math.abs(change));
    return change > 0
      ? `Input from data reports and analytics has resulted in an increase of ${numberWithCurrency} to your premium.`
      : `Input from data reports and analytics has resulted in a decrease of ${numberWithCurrency} to your premium.`
  }

  const setPolicyTotalPremiumAmt = (policyTotalPremiumAmt)=>{
    setShowAlert(false);
    setPolicyTotalPremium(policyTotalPremiumAmt);
    setPaymentTotalPremium(-1);
  }
  const setPaymentTotalPremiumAmt = (paymentTotalPremiumAmt)=>{
    // Handle refresh page case, alert message would be showing when user refresh page,
    // only show alert message when it comes from policy info page.
    if (policyTotalPremium !== paymentTotalPremiumAmt
        && paymentTotalPremium === -1
        && policyTotalPremium !== -1){
      setShowAlert(true);

      const message = generateMessage(policyTotalPremium, paymentTotalPremiumAmt);
      setMessage(message)
    }else {
      setShowAlert(false);
      setMessage('');
    }
  }

  return (
    <PremiumAlertMessageContext.Provider
      value={{
        showAlert,
        setShowAlert,
        message,
        setPolicyTotalPremiumAmt,
        setPaymentTotalPremiumAmt
      }}
    >
      {children}
    </PremiumAlertMessageContext.Provider>
  );
};



export default PremiumAlertMessageProvider;
